"use strict";exports.__esModule = true;exports.default = void 0;class _default {
  toggleDetails(ev) {
    this.emit('toggle', { originalEvent: ev, open: this.getEl('root').open });
  }
  clickDetails(ev) {
    this.emit('click', { originalEvent: ev });
  }}exports.default = _default;module.exports = exports.default;